module.exports = __webpack_public_path__ + "static/media/Credits-43.9e038ba0.pdf";